import { LambdaSchema } from "./types";

const schema: LambdaSchema = {
  columns: [
    { key: "summarize_job_name", label: "summarize_job_name" },
    { key: "llm_calls", label: "llm_calls" },
    { key: "specialty", label: "specialty" },
    { key: "macros_applied", label: "macros_applied" }
  ],
};

export default schema;

